import React from "react";

import { Helmet } from "react-helmet";

import { Routes, Route, Navigate } from "react-router-dom";


import { createUseStyles } from "react-jss";

import AuthNavbar from "components/Navigation/Navbars/Auth/AuthNavbar";

import { dashRoutes as routes } from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/blogStyle.js";
import Footer from "components/Sales/Footer";
import Banner from "components/Sales/Banner";

const useStyles = createUseStyles(styles);

export default function PricingLayout(props) {
  const classes = useStyles();
  const { ...rest } = props;

  const getRoutes = (routes) => {
    return routes
      .filter((prop) => prop.layout === "/about")
      .map((prop, key) => {
        if (prop.collapse) {
          return getRoutes(prop.views);
        }
        return (
          <Route path={prop.path} element={<prop.component />} key={key} />
        );
      });
  };

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Stakeholders.app Pricing | Professional, Free</title>
        <meta
          name="description"
          content="Stakeholders.app Pricing | Professional, Free Tier - Stakeholder Mapping and Analysis"
        />
      </Helmet>
      <div className={classes.fullPage}>
        <AuthNavbar {...rest} shrinkOnValue={275} />

        <div className={classes.content}>
          <Banner small />
          <div className={classes.container + " " + classes.padding}>
            <Routes>
              {getRoutes(routes)}
              <Route path="/*" element={<Navigate to="/about" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
